import GallectionsSection from './GallectionsSection';
import GallectionsSectionContainer from './GallectionsSection.container';

export default GallectionsSectionContainer(GallectionsSection);
